import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
const styles = {
  infoRecord: {
    fontSize: "0.8rem",
    color: "#546e7a",
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};
class InfoRecord extends React.Component {
  render() {
    const { classes, t } = this.props;
    const { total = 0, infoServiceBranch = {} } = this.props;

    return (
      <div className={classes.frameTitle}>
        <Typography className={classes.infoRecord} gutterBottom>
          {total} {t("customer_listcustomer_record_found")}
        </Typography>
        <Typography className={classes.infoRecord} gutterBottom>
          {infoServiceBranch && infoServiceBranch.address}
          {infoServiceBranch && infoServiceBranch.mobile && ". ✆ "}
          {infoServiceBranch && infoServiceBranch.mobile}
        </Typography>
      </div>
    );
  }
}

InfoRecord.propTypes = {
  // onChange: PropTypes.func.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(InfoRecord)));
